interface LogEntry {
  ts: number;
  level: string;
  msg: string;
  [key: string]: unknown;
}

const _buffer: LogEntry[] = [];
const FLUSH_INTERVAL = 30_000;
const MAX_BUFFER = 200;

export function log(level: string, msg: string, data?: Record<string, unknown>) {
  if (_buffer.length >= MAX_BUFFER) return;
  _buffer.push({ ts: Date.now() / 1000, level, msg, ...data });
}

function flush() {
  if (!_buffer.length) return;
  const batch = _buffer.splice(0);
  try {
    const blob = new Blob([JSON.stringify(batch)], { type: 'application/json' });
    navigator.sendBeacon('/api/logs', blob);
  } catch {
    /* best effort */
  }
}

let _routeStart = 0;

export function markRouteStart() {
  _routeStart = performance.now();
}

export function markRouteEnd(path: string) {
  if (!_routeStart) return;
  const elapsed = Math.round(performance.now() - _routeStart);
  log('info', `route:${path}`, { elapsed_ms: elapsed });
  _routeStart = 0;
}

export function logApiCall(path: string, method: string, status: number, elapsed_ms: number) {
  const level = status >= 500 ? 'error' : status >= 400 ? 'warn' : 'info';
  log(level, `api:${method} ${path}`, { status, elapsed_ms });
}

export function initLogCollector() {
  setInterval(flush, FLUSH_INTERVAL);
  window.addEventListener('beforeunload', flush);

  window.addEventListener('error', (e) => {
    log('error', e.message || 'unknown error', {
      file: e.filename,
      line: e.lineno,
      col: e.colno,
    });
  });

  window.addEventListener('unhandledrejection', (e) => {
    log('error', `unhandledrejection: ${String(e.reason)}`);
  });

  log('info', 'log_collector initialized', {
    ua: navigator.userAgent.slice(0, 120),
    url: location.href,
  });
}
